<template>
  <div>
    <nav class="nav navbar-inverse navbar-fixed-top " id="nava">
      <div class="headerNavWidth">
        <div class="navbar-header">
          <!-- 小屏时导航样式 -->
          <button  v-if="!isBack"  class="navbar-toggle" data-toggle="collapse" data-target="#menu">
            <img class="more" src="static/img/more.png" alt=""/>
          </button>
          <!-- <a href="home.html" class="navbar-left bg"> </a> -->
          <a class="navbar-left bg"  @click="backhome()"  title="佰付美营销合作平台">
            <img class="img-responsive" src="static/img/logos.png" alt="">
            <p class="logotxt">佰付美营销合作平台</p>
          </a>
        </div>
        <div id="menu" class="collapse navbar-collapse navbar-right">
          <ul class="nav navbar-nav">
            <li v-for="(nl, index) in this.$store.state.allRouter" :key="index" class="menu-item dropdown" v-if="isBack">
              <a data-toggle="dropdown" class="dropdown-toggle" :class="(index == comfIndex) ? 'selectedText': ''" aria-expanded="true" @click="toPath(nl.url,index)">
                {{nl.showName}} <span class="caret" v-if=" nl.children "></span>
              </a>
              <!--  data-target="#menu" -->
              <!-- <ul v-if=" nl.children " id="xsNav" data-toggle="collapse" aria-expanded="false" aria-controls="navbar" role="menu" class="open dropdown-menu mydropdown">
                <div class="listnav ">
                  <li class="menu-item"  v-for="(nlc, cIndex) in nl.children" :key="cIndex">
                    <a  @click="toPath(nlc.url, index, cIndex)" :class=" (index == comfIndex && (cIndex == comCIndex)) ? 'selectedText': ''">
                      <p :style="(index == comfIndex && (cIndex == comCIndex)) ? {'background-image' : 'url(' + nlc.icon + ')'} : {'background-image' : 'url(' + nlc.noicon + ')'}" ></p>
                      {{nlc.showName}}
                    </a>
                  </li>
                </div>
              </ul> -->
            </li>
            <li class="menu-item">
              <a class="navbar-left bg" href="https://www.epaynfc.com/" title="返回维纳官网">
                返回维纳官网
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  export default {
    name: "HelloWorld",
    data() {
      return {
        togo:null,
        clickchange:false,
        isBack: false
      };
    },
    mounted() {
      this.scrollWindow();
      this.dropdownOpen();
      if(document.body.clientWidth > 768){
        $(document).off('click.bs.dropdown.data-api');
      }
    },
    methods: {
      backhome(){
        this.$router.push({"path": "/" })
      },
      toPath(url, findex, cindex){
        if(url){
          if(cindex){
            var data = {
              fIndex: findex,
              cIndex: cindex
            }
          }else{
            var data = {
              fIndex: findex,
              cIndex: 0
            }
          }
          this.$store.commit("updateSelect", data);
          this.fIndex = data.fIndex;
          this.CIndex = data.cIndex;
          if ($(window).width() < 767) {
            $("#menu").removeClass('show');
          }
          this.$router.push({"path": url })
        }
      },
      dropdownOpen() {
        var $dropdownLi = $("li.dropdown");
        $dropdownLi.mouseover(function() {
            $(this).addClass("open");
          })
          .mouseout(function() {
            $(this).removeClass("open");
        });
        if ($(window).width() > 768) {
          $(document).off('click.bs.dropdown.data-api');
          //鼠标划过就展开子菜单
          $("ul.nav li.dropdown").hover(
            function() {
              $(this)
                .find(".dropdown-menu")
                .stop(true, true)
                .slideDown();
            },
            function() {
              $(this)
                .find(".dropdown-menu")
                .stop(true, true)
                .slideUp();
            }
          );
        }else{
          $("#menu").removeClass('show');
        }
      },
      scrollWindow() {
        var that = this;
        $(window).scroll(function() {
          var $w = $(this),
            st = $w.scrollTop(),
            navbar = $(".navbar-inverse");
          if (st > 120) {
            if (!navbar.hasClass("scrolled")) {
              navbar.addClass("scrolled");
            }
          }
          if (st < 120) {
            if (navbar.hasClass("scrolled")) {
              navbar.removeClass("scrolled sleep");
            }
          }
          if (st > 130) {
            if (!navbar.hasClass("awake")) {
              navbar.addClass("awake");
            }
          }
          if (st < 130) {
            if (navbar.hasClass("awake")) {
              navbar.removeClass("awake");
              navbar.addClass("sleep");
            }
          }
        });
      }
    },
    computed:{
      comfIndex () {
        return this.$store.state.fIndex
      },
      comCIndex(){
        return this.$store.state.CIndex
      }
    }
  };
</script>
<style scoped lang="scss">
  @import "../assets/css/publicsty";

</style>



// WEBPACK FOOTER //
// src/components/header.vue